import { useTheme } from "../contexts/ThemeContext";

function useCustomStyles(): { customStyles: any } {
    const { theme } = useTheme();
    const customStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            background: isFocused
                ? "hsla(291, 64%, 42%, 0.5)"
                : isSelected
                    ? "hsla(291, 64%, 42%, 1)"
                    : undefined,
            zIndex: 1,
        }),
        menuList: (styles) => ({
            ...styles,
            background: theme === "dark" ? "#3b3b3b" : "#ffffff",
            color: theme === "dark" ? "white" : "",
        }),
        menu: (base) => ({
            ...base,
            zIndex: 100,
        }),
        control: (base, state) => ({
            ...base,
            background: theme === "dark" ? "#25273a" : "#f2f2f2",
            borderRadius: "0.4285rem",
            borderColor: state.isFocused
                ? "#1d8cf8"
                : theme !== "light"
                    ? "#2b3553"
                    : "",
            boxShadow: state.isFocused ? null : null,
            "&:hover": {
                borderColor: state.isFocused ? "" : "#ba54f5",
            },
            '& .react-select__input input[type="color"]': {
                color: theme === "dark" ? "red" : "black",
            },
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === "dark" ? "white" : "black",
        }),
        input: (base) => ({
            ...base,
            color: theme === "dark" ? "white" : "black",
        }),
    };

    return { customStyles };
}

export default useCustomStyles;